import type { FC } from 'react';

interface Props {
  className?: string;
}

const CountertopIcon: FC<Props> = ({ className = 'w-5 h-5 mr-1' }) => {
  return (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <rect x="3" y="8" width="18" height="4" rx="1" strokeWidth="2" />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6 8V6a2 2 0 012-2h8a2 2 0 012 2v2M6 12v8M10 12v8M14 12v8M18 12v8"
      />
      <circle cx="8" cy="10" r="1" fill="currentColor" />
      <circle cx="16" cy="10" r="1" fill="currentColor" />
    </svg>
  );
};

export default CountertopIcon;
